import { isBrowser } from "browser-or-node";

export const clearHash = (): void => {
  if (isBrowser) window.location.hash = "";
};

export const setHash = (hash: string): void => {
  if (isBrowser) window.location.hash = hash;
};
